export interface CompanyInvoicingType {
  id: number;
  companyId: number;
  year: number;
  invoicingType: InvoicingTypeEnum;
}

export interface CreateCompanyInvoicingTypePayload {
  companyId: number;
  year: number;
  invoicingType: InvoicingTypeEnum;
}

export interface UpdateCompanyInvoicingTypePayload {
  id: number;
  companyId: number;
  year: number;
  invoicingType: InvoicingTypeEnum;
}

export enum InvoicingTypeEnum {
  YEAR_ESTIMATE_QUARTERLY = "YEAR_ESTIMATE_QUARTERLY",
  YEAR_ESTIMATE_MONTHLY = "YEAR_ESTIMATE_MONTHLY",
  QUARTERLY = "QUARTERLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEAR",
}
